export function formatUsageMetric(value, available = true) {
  if (available === false || value == null || value === '') return 'Unavailable';
  return String(value);
}

export function somUsageEmpty(data) {
  return !data || data.has_data === false;
}

export function somReconciliationLabel(data) {
  const recon = data?.reconciliation || {};
  if (recon.value_state === 'unavailable' || recon.status == null) return 'Unavailable';
  return recon.status_label || 'Unavailable';
}
